// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1JUwC","title":"Header_title__2h3ww","left":"Header_left__3g1zI","clinicName":"Header_clinicName__BDRTy"};